import { doc, getDoc, setDoc } from 'firebase/firestore';
import { ref, getBytes } from 'firebase/storage';
import { httpsCallable } from 'firebase/functions';
import { db, storage, functions } from '../firebase';

// Summary built by the refreshAnalytics Cloud Function (daily at 07:00 or on demand)
export async function loadAnalytics() {
  try {
    const bytes = await getBytes(ref(storage, 'admin-cache/analytics.json'));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch {
    return null;
  }
}

export async function refreshAnalytics() {
  const fn = httpsCallable(functions, 'refreshAnalytics');
  const result = await fn();
  return result.data;
}

// Spend-change markers ("paused ads", "doubled budget") shown on the daily charts
const META_DOC = doc(db, 'analytics', 'meta');

export async function loadMarkers() {
  const snap = await getDoc(META_DOC);
  return snap.exists() ? (snap.data().markers || []) : [];
}

export async function saveMarkers(markers) {
  const sorted = [...markers].sort((a, b) => a.date.localeCompare(b.date));
  await setDoc(META_DOC, { markers: sorted }, { merge: true });
  return sorted;
}

// Summary for the Engagement tab, built by the refreshEngagement Cloud Function (when the tab is opened)
export async function loadEngagement() {
  try {
    const bytes = await getBytes(ref(storage, 'admin-cache/engagement.json'));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch {
    return null;
  }
}

export async function refreshEngagement() {
  const fn = httpsCallable(functions, 'refreshEngagement');
  const result = await fn();
  return result.data;
}
